import React, {
  useState,
} from 'react';

import { TableTabContainer } from '../styles';
import {
  ActionType,
  isEditAction,
  isEditorView,
  isBulkCreateView,
} from './utils';
import ExerciseEditor from './ExerciseEditor';
import ExercisesTable from './ExercisesTable';
import BulkExerciseCreator from './BulkExerciseCreator';

const Exercises = () => {
  const [selectedExercise, setSelectedExercise] = useState(null);
  const [actionPerformed, setActionPerformed] = useState(null);

  const handleActionClick = (exercise, action) => {
    setSelectedExercise(exercise);
    setActionPerformed(action);
  };

  const renderContent = () => {
    if (isBulkCreateView(actionPerformed)) {
      return (
        <BulkExerciseCreator
          onClose={() => handleActionClick(null, null)}
        />
      );
    }
    if (isEditorView(actionPerformed, selectedExercise)) {
      return (
        <ExerciseEditor
          selectedExercise={selectedExercise}
          isEditView={isEditAction(actionPerformed, selectedExercise)}
          onClose={() => handleActionClick(null, null)}
        />
      );
    }
    return (
      <ExercisesTable
        selectedExercise={selectedExercise}
        actionPerformed={actionPerformed}
        handleActionClick={handleActionClick}
      />
    );
  };

  return (
    <TableTabContainer>
      {renderContent()}
    </TableTabContainer>
  );
};

export default Exercises;
export {
  ActionType,
};
